"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RightsConst = function () {
  function RightsConst() {}
  RightsConst.LZ = 'LZ';
  RightsConst.VZ = 'VZ';
  RightsConst.SHOW_LOCKED_PER = 'SHOW_LOCKED_PER';
  RightsConst.SHOW_LOCKED_POL = 'SHOW_LOCKED_POL';
  RightsConst.SHOW_LOCKED_SCH = 'SHOW_LOCKED_SCH';
  RightsConst.nv_BILDUNG_ARCHIVE = 'nv:BILDUNG_ARCHIVE';
  RightsConst.nv_BILDUNG_CHANGE = 'nv:BILDUNG_CHANGE';
  RightsConst.nv_BILDUNG = 'nv:BILDUNG';
  RightsConst.nv_BILDUNG_DEL = 'nv:BILDUNG_DEL';
  RightsConst.nv_BUCHHALTUNG_ARCHIVE = 'nv:BUCHHALTUNG_ARCHIVE';
  RightsConst.nv_BUCHHALTUNG_CHANGE = 'nv:BUCHHALTUNG_CHANGE';
  RightsConst.pd_BUCHHALTUNG_INF_SEK = 'pd:BUCHHALTUNG_INF_SEK';
  RightsConst.pd_BUCHHALTUNG_INKASSO_ARCHIVE = 'pd:BUCHHALTUNG_INKASSO_ARCHIVE';
  RightsConst.pd_BUCHHALTUNG_INKASSO_CHANGE = 'pd:BUCHHALTUNG_INKASSO_CHANGE';
  RightsConst.pd_BUCHHALTUNG_INKASSO = 'pd:BUCHHALTUNG_INKASSO';
  RightsConst.pd_BUCHHALTUNG_INKASSO_DEL = 'pd:BUCHHALTUNG_INKASSO_DEL';
  RightsConst.nv_BUCHHALTUNG = 'nv:BUCHHALTUNG';
  RightsConst.pd_BUCHHALTUNG_LIEGENSCHAFTEN_ARCHIVE = 'pd:BUCHHALTUNG_LIEGENSCHAFTEN_ARCHIVE';
  RightsConst.pd_BUCHHALTUNG_LIEGENSCHAFTEN_CHANGE = 'pd:BUCHHALTUNG_LIEGENSCHAFTEN_CHANGE';
  RightsConst.pd_BUCHHALTUNG_LIEGENSCHAFTEN = 'pd:BUCHHALTUNG_LIEGENSCHAFTEN';
  RightsConst.pd_BUCHHALTUNG_LIEGENSCHAFTEN_DEL = 'pd:BUCHHALTUNG_LIEGENSCHAFTEN_DEL';
  RightsConst.nv_BUCHHALTUNG_DEL = 'nv:BUCHHALTUNG_DEL';
  RightsConst.pd_BUCHHALTUNG_ODN_SEK = 'pd:BUCHHALTUNG_ODN_SEK';
  RightsConst.pd_BUCHHALTUNG_VERKAUF_ARCHIVE = 'pd:BUCHHALTUNG_VERKAUF_ARCHIVE';
  RightsConst.pd_BUCHHALTUNG_VERKAUF_CHANGE = 'pd:BUCHHALTUNG_VERKAUF_CHANGE';
  RightsConst.pd_BUCHHALTUNG_VERKAUF = 'pd:BUCHHALTUNG_VERKAUF';
  RightsConst.pd_BUCHHALTUNG_VERKAUF_DEL = 'pd:BUCHHALTUNG_VERKAUF_DEL';
  RightsConst.pd_BUCHHALTUNG_VPC_ARCHIVE = 'pd:BUCHHALTUNG_VPC_ARCHIVE';
  RightsConst.pd_BUCHHALTUNG_VPC_CHANGE = 'pd:BUCHHALTUNG_VPC_CHANGE';
  RightsConst.pd_BUCHHALTUNG_VPC = 'pd:BUCHHALTUNG_VPC';
  RightsConst.pd_BUCHHALTUNG_VPC_DEL = 'pd:BUCHHALTUNG_VPC_DEL';
  RightsConst.pd_BUCHHALTUNG_VPC_SEK_ARCHIVE = 'pd:BUCHHALTUNG_VPC_SEK_ARCHIVE';
  RightsConst.pd_BUCHHALTUNG_VPC_SEK_CHANGE = 'pd:BUCHHALTUNG_VPC_SEK_CHANGE';
  RightsConst.pd_BUCHHALTUNG_VPC_SEK = 'pd:BUCHHALTUNG_VPC_SEK';
  RightsConst.pd_BUCHHALTUNG_VPC_SEK_DEL = 'pd:BUCHHALTUNG_VPC_SEK_DEL';
  RightsConst.pd_BUCHHALTUNG_VST_VERKAUF_ARCHIVE = 'pd:BUCHHALTUNG_VST_VERKAUF_ARCHIVE';
  RightsConst.pd_BUCHHALTUNG_VST_VERKAUF_CHANGE = 'pd:BUCHHALTUNG_VST_VERKAUF_CHANGE';
  RightsConst.pd_BUCHHALTUNG_VST_VERKAUF = 'pd:BUCHHALTUNG_VST_VERKAUF';
  RightsConst.pd_BUCHHALTUNG_VST_VERKAUF_DEL = 'pd:BUCHHALTUNG_VST_VERKAUF_DEL';
  RightsConst.nv_CONTROLLING_ARCHIVE = 'nv:CONTROLLING_ARCHIVE';
  RightsConst.nv_CONTROLLING_CHANGE = 'nv:CONTROLLING_CHANGE';
  RightsConst.nv_CONTROLLING = 'nv:CONTROLLING';
  RightsConst.nv_CONTROLLING_DEL = 'nv:CONTROLLING_DEL';
  RightsConst.nv_DSGVO_ARCHIVE = 'nv:DSGVO_ARCHIVE';
  RightsConst.nv_DSGVO_CHANGE = 'nv:DSGVO_CHANGE';
  RightsConst.nv_DSGVO = 'nv:DSGVO';
  RightsConst.nv_DSGVO_DEL = 'nv:DSGVO_DEL';
  RightsConst.nv_FACHSEK_ARCHIVE = 'nv:FACHSEK_ARCHIVE';
  RightsConst.nv_FACHSEK_CHANGE = 'nv:FACHSEK_CHANGE';
  RightsConst.nv_FACHSEK = 'nv:FACHSEK';
  RightsConst.nv_FACHSEK_DEL = 'nv:FACHSEK_DEL';
  RightsConst.nv_FINANZSEK_ARCHIVE = 'nv:FINANZSEK_ARCHIVE';
  RightsConst.nv_FINANZSEK_CHANGE = 'nv:FINANZSEK_CHANGE';
  RightsConst.nv_FINANZSEK = 'nv:FINANZSEK';
  RightsConst.nv_FINANZSEK_DEL = 'nv:FINANZSEK_DEL';
  RightsConst.nv_GENERALSEK_ARCHIVE = 'nv:GENERALSEK_ARCHIVE';
  RightsConst.nv_GENERALSEK_CHANGE = 'nv:GENERALSEK_CHANGE';
  RightsConst.nv_GENERALSEK = 'nv:GENERALSEK';
  RightsConst.nv_GENERALSEK_DEL = 'nv:GENERALSEK_DEL';
  RightsConst.pd_GENERALSEK_ARCHIVE = 'pd:GENERALSEK_ARCHIVE';
  RightsConst.pd_GENERALSEK_CHANGE = 'pd:GENERALSEK_CHANGE';
  RightsConst.pd_GENERALSEK = 'pd:GENERALSEK';
  RightsConst.pd_GENERALSEK_DEL = 'pd:GENERALSEK_DEL';
  RightsConst.nv_GUTACHTEN_ARCHIVE = 'nv:GUTACHTEN_ARCHIVE';
  RightsConst.nv_GUTACHTEN_CHANGE = 'nv:GUTACHTEN_CHANGE';
  RightsConst.nv_GUTACHTEN = 'nv:GUTACHTEN';
  RightsConst.nv_GUTACHTEN_DEL = 'nv:GUTACHTEN_DEL';
  RightsConst.nv_INKASSO_ARCHIVE = 'nv:INKASSO_ARCHIVE';
  RightsConst.nv_INKASSO_CHANGE = 'nv:INKASSO_CHANGE';
  RightsConst.nv_INKASSO = 'nv:INKASSO';
  RightsConst.nv_INKASSO_DEL = 'nv:INKASSO_DEL';
  RightsConst.pd_NOEV_ARCHIVE = 'pd:NOEV_ARCHIVE';
  RightsConst.pd_NOEV_CHANGE = 'pd:NOEV_CHANGE';
  RightsConst.pd_NOEV = 'pd:NOEV';
  RightsConst.pd_NOEV_DEL = 'pd:NOEV_DEL';
  RightsConst.nv_NOEV_ARCHIVE = 'nv:NOEV_ARCHIVE';
  RightsConst.nv_NOEV_CHANGE = 'nv:NOEV_CHANGE';
  RightsConst.nv_NOEV = 'nv:NOEV';
  RightsConst.nv_NOEV_DEL = 'nv:NOEV_DEL';
  RightsConst.nv_ISSEK_ARCHIVE = 'nv:ISSEK_ARCHIVE';
  RightsConst.nv_ISSEK_CHANGE = 'nv:ISSEK_CHANGE';
  RightsConst.nv_ISSEK = 'nv:ISSEK';
  RightsConst.nv_ISSEK_DEL = 'nv:ISSEK_DEL';
  RightsConst.nv_TEST_ARCHIVE = 'nv:TEST_ARCHIVE';
  RightsConst.nv_TEST_CHANGE = 'nv:TEST_CHANGE';
  RightsConst.nv_TEST = 'nv:TEST';
  RightsConst.nv_TEST_DEL = 'nv:TEST_DEL';
  RightsConst.pd_VERWALTUNG_ARCHIVE = 'pd:VERWALTUNG_ARCHIVE';
  RightsConst.pd_VERWALTUNG_CHANGE = 'pd:VERWALTUNG_CHANGE';
  RightsConst.pd_VERWALTUNG = 'pd:VERWALTUNG';
  RightsConst.pd_VERWALTUNG_DEL = 'pd:VERWALTUNG_DEL';
  RightsConst.nv_KFZ_ARCHIVE = 'nv:KFZ_ARCHIVE';
  RightsConst.nv_KFZ_CHANGE = 'nv:KFZ_CHANGE';
  RightsConst.nv_KFZ = 'nv:KFZ';
  RightsConst.nv_KFZ_DEL = 'nv:KFZ_DEL';
  RightsConst.pd_LEBEN_ARCHIVE = 'pd:LEBEN_ARCHIVE';
  RightsConst.pd_LEBEN_CHANGE = 'pd:LEBEN_CHANGE';
  RightsConst.pd_LEBEN = 'pd:LEBEN';
  RightsConst.pd_LEBEN_DEL = 'pd:LEBEN_DEL';
  RightsConst.pd_LEBEN_NO_VERTRAULICH_ARCHIVE = 'pd:LEBEN_NO_VERTRAULICH_ARCHIVE';
  RightsConst.pd_LEBEN_NO_VERTRAULICH_CHANGE = 'pd:LEBEN_NO_VERTRAULICH_CHANGE';
  RightsConst.pd_LEBEN_NO_VERTRAULICH = 'pd:LEBEN_NO_VERTRAULICH';
  RightsConst.pd_LEBEN_NO_VERTRAULICH_DEL = 'pd:LEBEN_NO_VERTRAULICH_DEL';
  RightsConst.nv_MARKETING_ARCHIVE = 'nv:MARKETING_ARCHIVE';
  RightsConst.nv_MARKETING_CHANGE = 'nv:MARKETING_CHANGE';
  RightsConst.nv_MARKETING = 'nv:MARKETING';
  RightsConst.nv_MARKETING_DEL = 'nv:MARKETING_DEL';
  RightsConst.nv_MITVERS_ARCHIVE = 'nv:MITVERS_ARCHIVE';
  RightsConst.nv_MITVERS_CHANGE = 'nv:MITVERS_CHANGE';
  RightsConst.nv_MITVERS = 'nv:MITVERS';
  RightsConst.nv_MITVERS_DEL = 'nv:MITVERS_DEL';
  RightsConst.nv_PERSONAL_ARCHIVE = 'nv:PERSONAL_ARCHIVE';
  RightsConst.nv_PERSONAL_CHANGE = 'nv:PERSONAL_CHANGE';
  RightsConst.nv_PERSONAL = 'nv:PERSONAL';
  RightsConst.nv_PERSONAL_DEL = 'nv:PERSONAL_DEL';
  RightsConst.nv_PERSAKT_ARCHIVE = 'nv:PERSAKT_ARCHIVE';
  RightsConst.nv_PERSAKT_CHANGE = 'nv:PERSAKT_CHANGE';
  RightsConst.nv_PERSAKT = 'nv:PERSAKT';
  RightsConst.nv_PERSAKT_DEL = 'nv:PERSAKT_DEL';
  RightsConst.nv_PERSDOK_ARCHIVE = 'nv:PERSDOK_ARCHIVE';
  RightsConst.nv_PERSDOK_CHANGE = 'nv:PERSDOK_CHANGE';
  RightsConst.nv_PERSDOK = 'nv:PERSDOK';
  RightsConst.nv_PERSDOK_DEL = 'nv:PERSDOK_DEL';
  RightsConst.nv_PROTOCOL_ARCHIVE = 'nv:PROTOCOL_ARCHIVE';
  RightsConst.nv_PROTOCOL_CHANGE = 'nv:PROTOCOL_CHANGE';
  RightsConst.nv_PROTOCOL = 'nv:PROTOCOL';
  RightsConst.nv_PROTOCOL_DEL = 'nv:PROTOCOL_DEL';
  RightsConst.nv_REVISION_ARCHIVE = 'nv:REVISION_ARCHIVE';
  RightsConst.nv_REVISION_CHANGE = 'nv:REVISION_CHANGE';
  RightsConst.nv_REVISION = 'nv:REVISION';
  RightsConst.nv_REVISION_DEL = 'nv:REVISION_DEL';
  RightsConst.nv_RUECKVERSICHERUNG_ARCHIVE = 'nv:RUECKVERSICHERUNG_ARCHIVE';
  RightsConst.nv_RUECKVERSICHERUNG_CHANGE = 'nv:RUECKVERSICHERUNG_CHANGE';
  RightsConst.nv_RUECKVERSICHERUNG = 'nv:RUECKVERSICHERUNG';
  RightsConst.nv_RUECKVERSICHERUNG_DEL = 'nv:RUECKVERSICHERUNG_DEL';
  RightsConst.nv_ESCHAD_DOK_ARCHIVE = 'nv:ESCHAD_DOK_ARCHIVE';
  RightsConst.nv_ESCHAD_DOK_CHANGE = 'nv:ESCHAD_DOK_CHANGE';
  RightsConst.nv_ESCHAD_DOK = 'nv:ESCHAD_DOK';
  RightsConst.nv_ESCHAD_DOK_DEL = 'nv:ESCHAD_DOK_DEL';
  RightsConst.nv_SCHADENSEK_ARCHIVE = 'nv:SCHADENSEK_ARCHIVE';
  RightsConst.nv_SCHADENSEK_CHANGE = 'nv:SCHADENSEK_CHANGE';
  RightsConst.nv_SCHADENSEK = 'nv:SCHADENSEK';
  RightsConst.nv_SCHADENSEK_DEL = 'nv:SCHADENSEK_DEL';
  RightsConst.nv_PERSB_ARCHIVE = 'nv:PERSB_ARCHIVE';
  RightsConst.nv_PERSB_CHANGE = 'nv:PERSB_CHANGE';
  RightsConst.nv_PERSB = 'nv:PERSB';
  RightsConst.nv_PERSB_DEL = 'nv:PERSB_DEL';
  RightsConst.nv_VERKADMIN_ARCHIVE = 'nv:VERKADMIN_ARCHIVE';
  RightsConst.nv_VERKADMIN_CHANGE = 'nv:VERKADMIN_CHANGE';
  RightsConst.nv_VERKADMIN = 'nv:VERKADMIN';
  RightsConst.nv_VERKADMIN_DEL = 'nv:VERKADMIN_DEL';
  RightsConst.nv_MAKLER_ARCHIVE = 'nv:MAKLER_ARCHIVE';
  RightsConst.nv_MAKLER_CHANGE = 'nv:MAKLER_CHANGE';
  RightsConst.nv_MAKLER = 'nv:MAKLER';
  RightsConst.nv_MAKLER_DEL = 'nv:MAKLER_DEL';
  RightsConst.nv_VERKSTEUERUNG_ARCHIVE = 'nv:VERKSTEUERUNG_ARCHIVE';
  RightsConst.nv_VERKSTEUERUNG_CHANGE = 'nv:VERKSTEUERUNG_CHANGE';
  RightsConst.nv_VERKSTEUERUNG = 'nv:VERKSTEUERUNG';
  RightsConst.nv_VERKSTEUERUNG_DEL = 'nv:VERKSTEUERUNG_DEL';
  RightsConst.pd_VERKSTEUBW_ARCHIVE = 'pd:VERKSTEUBW_ARCHIVE';
  RightsConst.pd_VERKSTEUBW_CHANGE = 'pd:VERKSTEUBW_CHANGE';
  RightsConst.pd_VERKSTEUBW = 'pd:VERKSTEUBW';
  RightsConst.pd_VERKSTEUBW_DEL = 'pd:VERKSTEUBW_DEL';
  RightsConst.ASP_PAK = 'ASP_PAK';
  RightsConst.ASP_ZUL = 'ASP_ZUL';
  RightsConst.PZ_ADMIN = 'PZ_ADMIN';
  RightsConst.PZ_ADRESSE = 'PZ_ADRESSE';
  RightsConst.UNLOCK_LOCKED_PER = 'UNLOCK_LOCKED_PER';
  RightsConst.UNLOCK_LOCKED_POL = 'UNLOCK_LOCKED_POL';
  RightsConst.UNLOCK_LOCKED_SCH = 'UNLOCK_LOCKED_SCH';
  RightsConst.GENEHM_ANTRAG = 'GENEHM_ANTRAG';
  RightsConst.PZ_DRUCK_ANTR = 'PZ_DRUCK_ANTR';
  RightsConst.PZ_DRUCK_ANTRAG = 'PZ_DRUCK_ANTRAG';
  RightsConst.PZ_ANWSTATUS = 'PZ_ANWSTATUS';
  RightsConst.PZ_APOLLOG = 'PZ_APOLLOG';
  RightsConst.PZ_DOCUMENTS_NOTE = 'PZ_DOCUMENTS_NOTE';
  RightsConst.PZ_DOCUMENTS_NOTE_AD = 'PZ_DOCUMENTS_NOTE_AD';
  RightsConst.PZ_ARCHIVADMIN = 'PZ_ARCHIVADMIN';
  RightsConst.PZ_ARCHIVCLIENT = 'PZ_ARCHIVCLIENT';
  RightsConst.PZ_ASSISTANCE = 'PZ_ASSISTANCE';
  RightsConst.PZ_BEZ = 'PZ_BEZ';
  RightsConst.PZ_BERATUNGSLEITFADEN = 'PZ_BERATUNGSLEITFADEN';
  RightsConst.PZ_DRUCK_BERAT = 'PZ_DRUCK_BERAT';
  RightsConst.PZ_BETREUER = 'PZ_BETREUER';
  RightsConst.PZ_BTR_RKT = 'PZ_BTR_RKT';
  RightsConst.PZ_BETDA = 'PZ_BETDA';
  RightsConst.PZ_BETREUER_KNOTEN = 'PZ_BETREUER_KNOTEN';
  RightsConst.PZ_PERSON_BBR = 'PZ_PERSON_BBR';
  RightsConst.PZ_BRIEFSYSTEM = 'PZ_BRIEFSYSTEM';
  RightsConst.PZ_DATENSCHUTZ = 'PZ_DATENSCHUTZ';
  RightsConst.PZ_DOCUMENTS = 'PZ_DOCUMENTS';
  RightsConst.PZ_DRUCK_AUSKUNFT = 'PZ_DRUCK_AUSKUNFT';
  RightsConst.PZ_DRUCK_LEBENDUPL = 'PZ_DRUCK_LEBENDUPL';
  RightsConst.PZ_DRUCK_KFZBESICHT = 'PZ_DRUCK_KFZBESICHT';
  RightsConst.PZ_DRUCK_GK_FLOTTE = 'PZ_DRUCK_GK_FLOTTE';
  RightsConst.GENEHM_LOCKED = 'GENEHM_LOCKED';
  RightsConst.PZ_ELA = 'PZ_ELA';
  RightsConst.PZ_ELEKKOM = 'PZ_ELEKKOM';
  RightsConst.PZ_ESIGN = 'PZ_ESIGN';
  RightsConst.PZ_ESIGN_RESET_EXPIRED = 'PZ_ESIGN_RESET_EXPIRED';
  RightsConst.PZ_ESIGN_LOG = 'PZ_ESIGN_LOG';
  RightsConst.PZ_FAHRZEUG = 'PZ_FAHRZEUG';
  RightsConst.PZ_FAMILIENPASS = 'PZ_FAMILIENPASS';
  RightsConst.PZ_FAMPASS_ABGL = 'PZ_FAMPASS_ABGL';
  RightsConst.PZ_GEBAEUDE = 'PZ_GEBAEUDE';
  RightsConst.PZ_KND_GEBDAT = 'PZ_KND_GEBDAT';
  RightsConst.PZ_GEHALTSUMW = 'PZ_GEHALTSUMW';
  RightsConst.GENEHM = 'GENEHM';
  RightsConst.PZ_GRK_BRIEFE = 'PZ_GRK_BRIEFE';
  RightsConst.PZ_HAUSHALT = 'PZ_HAUSHALT';
  RightsConst.PZ_HOTLINE = 'PZ_HOTLINE';
  RightsConst.PZ_HUNDEHAFT_UNLIMIT = 'PZ_HUNDEHAFT_UNLIMIT';
  RightsConst.PZ_INDEX = 'PZ_INDEX';
  RightsConst.PZ_INFO = 'PZ_INFO';
  RightsConst.PZ_INTMERK = 'PZ_INTMERK';
  RightsConst.PZ_GUI = 'PZ_GUI';
  RightsConst.PZ_KND_KARTE = 'PZ_KND_KARTE';
  RightsConst.PZ_KONTAKT = 'PZ_KONTAKT';
  RightsConst.PZ_KOR_INFINICA = 'PZ_KOR_INFINICA';
  RightsConst.PZ_KUN_BRIEFE = 'PZ_KUN_BRIEFE';
  RightsConst.PZ_KNDA_ZUSA = 'PZ_KNDA_ZUSA';
  RightsConst.PZ_KNDA_KUML = 'PZ_KNDA_KUML';
  RightsConst.PZ_KARLCMS = 'PZ_KARLCMS';
  RightsConst.PZ_VERBUND = 'PZ_VERBUND';
  RightsConst.PZ_RKW = 'PZ_RKW';
  RightsConst.PZ_VERTCOCKLINK = 'PZ_VERTCOCKLINK';
  RightsConst.PZ_MAHNSTAND = 'PZ_MAHNSTAND';
  RightsConst.PZ_MD = 'PZ_MD';
  RightsConst.PZ_MAKLERDOCADMIN = 'PZ_MAKLERDOCADMIN';
  RightsConst.PZ_MOTORSTEUER = 'PZ_MOTORSTEUER';
  RightsConst.PZ_PARTNER = 'PZ_PARTNER';
  RightsConst.PZ_PARTNERADMIN = 'PZ_PARTNERADMIN';
  RightsConst.PZ_PARTNERADMIN_READ = 'PZ_PARTNERADMIN_READ';
  RightsConst.PZ_PERSON = 'PZ_PERSON';
  RightsConst.PZ_PDO = 'PZ_PDO';
  RightsConst.PZ_PDO_CREATE = 'PZ_PDO_CREATE';
  RightsConst.PZ_PDO_ELK = 'PZ_PDO_ELK';
  RightsConst.PZ_PDO_FLOTTE = 'PZ_PDO_FLOTTE';
  RightsConst.PZ_PDO_KMA = 'PZ_PDO_KMA';
  RightsConst.PZ_PVM = 'PZ_PVM';
  RightsConst.PZ_PVM_CREATE = 'PZ_PVM_CREATE';
  RightsConst.PZ_PVM_CREATE_VME = 'PZ_PVM_CREATE_VME';
  RightsConst.PZ_POLIZZE = 'PZ_POLIZZE';
  RightsConst.PZ_PLD_JKM = 'PZ_PLD_JKM';
  RightsConst.PZ_PLD_UEB = 'PZ_PLD_UEB';
  RightsConst.PZ_POLDRUCK = 'PZ_POLDRUCK';
  RightsConst.PZ_POLDRUCKLEBEN = 'PZ_POLDRUCKLEBEN';
  RightsConst.PZ_POLDRUCKLEBENWORD = 'PZ_POLDRUCKLEBENWORD';
  RightsConst.PZ_POLDRUCK_ADM = 'PZ_POLDRUCK_ADM';
  RightsConst.PZ_POLDRUCK_SK = 'PZ_POLDRUCK_SK';
  RightsConst.PZ_POLDRUCKWORD = 'PZ_POLDRUCKWORD';
  RightsConst.PZ_LBILANZ = 'PZ_LBILANZ';
  RightsConst.PZ_PROV = 'PZ_PROV';
  RightsConst.PZ_PROV_EING = 'PZ_PROV_EING';
  RightsConst.PZ_REFERATADMIN = 'PZ_REFERATADMIN';
  RightsConst.PZ_REFERATE = 'PZ_REFERATE';
  RightsConst.PZ_SCHADEN = 'PZ_SCHADEN';
  RightsConst.PZ_SCH_BETEIL = 'PZ_SCH_BETEIL';
  RightsConst.PZ_SCH_BETEILI = 'PZ_SCH_BETEILI';
  RightsConst.PZ_SCHZAHLADMIN = 'PZ_SCHZAHLADMIN';
  RightsConst.PZ_SCHZAHLEMPF = 'PZ_SCHZAHLEMPF';
  RightsConst.PZ_FASTSEARCH = 'PZ_FASTSEARCH';
  RightsConst.PZ_FASTSEARCH_FULL = 'PZ_FASTSEARCH_FULL';
  RightsConst.PZ_SOFTPHONE = 'PZ_SOFTPHONE';
  RightsConst.GENEHM_SONDER = 'GENEHM_SONDER';
  RightsConst.PZ_DRUCK_STATUS = 'PZ_DRUCK_STATUS';
  RightsConst.PZ_SVS = 'PZ_SVS';
  RightsConst.PZ_DBTEXTE = 'PZ_DBTEXTE';
  RightsConst.PZ_TEXTE = 'PZ_TEXTE';
  RightsConst.PZ_TODO = 'PZ_TODO';
  RightsConst.PZ_GFB = 'PZ_GFB';
  RightsConst.PZ_VSP = 'PZ_VSP';
  RightsConst.PZ_VSB = 'PZ_VSB';
  RightsConst.PZ_VERSBEST = 'PZ_VERSBEST';
  RightsConst.PZ_VERSBEST_BL = 'PZ_VERSBEST_BL';
  RightsConst.PZ_VERSBEST_UNLIMIT = 'PZ_VERSBEST_UNLIMIT';
  RightsConst.PZ_LD = 'PZ_LD';
  RightsConst.PZ_VERTRETER = 'PZ_VERTRETER';
  RightsConst.PZ_VERTRETER_OMDS = 'PZ_VERTRETER_OMDS';
  RightsConst.PZ_VERTRETER_BUC = 'PZ_VERTRETER_BUC';
  RightsConst.PZ_VERTRETER_DATEN = 'PZ_VERTRETER_DATEN';
  RightsConst.PZ_WARTDIENST = 'PZ_WARTDIENST';
  RightsConst.PZ_WT_KASKOUMST = 'PZ_WT_KASKOUMST';
  RightsConst.PZ_WT_SPARTENENTF = 'PZ_WT_SPARTENENTF';
  RightsConst.PZ_WT_ZAHLWEISE = 'PZ_WT_ZAHLWEISE';
  RightsConst.PZ_ZAHLUNGEN = 'PZ_ZAHLUNGEN';
  RightsConst.PZ_BESTAND_KFZ = 'PZ_BESTAND_KFZ';
  RightsConst.PZ_ZULASSUNG = 'PZ_ZULASSUNG';
  RightsConst.ELA_ESCHA_READ = 'ELA_ESCHA_READ';
  RightsConst.ELA_GRK_SAN = 'ELA_GRK_SAN';
  RightsConst.ELA_KEYUSER = 'ELA_KEYUSER';
  RightsConst.ELA_KONTR = 'ELA_KONTR';
  RightsConst.ELA_CHEFKONTR = 'ELA_CHEFKONTR';
  RightsConst.ELA_NEXA = 'ELA_NEXA';
  RightsConst.ELA_RISIKOKLAS = 'ELA_RISIKOKLAS';
  RightsConst.ELA_SAMMELPOL = 'ELA_SAMMELPOL';
  RightsConst.ELA_SAMMELPOL_VERW = 'ELA_SAMMELPOL_VERW';
  RightsConst.EMA_WRITE_TO_AKT = 'EMA_WRITE_TO_AKT';
  RightsConst.EMA_READ_AD_AKTEN = 'EMA_READ_AD_AKTEN';
  RightsConst.EMA_SELF_GEN_ALL = 'EMA_SELF_GEN_ALL';
  RightsConst.EMA_READ_ALL_AKTEN = 'EMA_READ_ALL_AKTEN';
  RightsConst.EMA_GRP_VTR = 'EMA_GRP_VTR';
  RightsConst.EMA_GRP_GL = 'EMA_GRP_GL';
  RightsConst.EMA_GRP_KB = 'EMA_GRP_KB';
  RightsConst.EMA_GRP_RD = 'EMA_GRP_RD';
  RightsConst.EMA_GRP_ZENTRALE_DIREKTION = 'EMA_GRP_ZENTRALE_DIREKTION';
  RightsConst.EMA_GRP_ZENTRALE_MAKLER = 'EMA_GRP_ZENTRALE_MAKLER';
  RightsConst.EMA_GRP_ZENTRALE_MARKTMGMNT = 'EMA_GRP_ZENTRALE_MARKTMGMNT';
  RightsConst.EMA_GRP_ZENTRALE_PARTNER = 'EMA_GRP_ZENTRALE_PARTNER';
  RightsConst.EMA_AKTTEILUNG = 'EMA_AKTTEILUNG';
  RightsConst.EMA_VMC_ADMIN_MANAGER = 'EMA_VMC_ADMIN_MANAGER';
  RightsConst.EMA_GEN_COMPLIANCE = 'EMA_GEN_COMPLIANCE';
  RightsConst.EMA_VIEW_AKT_HISTORY = 'EMA_VIEW_AKT_HISTORY';
  RightsConst.EMA_SELF_GEN_GRP = 'EMA_SELF_GEN_GRP';
  RightsConst.EMA_VMC_ADMIN_VISITOR = 'EMA_VMC_ADMIN_VISITOR';
  RightsConst.EMA_GEN_MAK = 'EMA_GEN_MAK';
  RightsConst.EMA_UV_MANAGER = 'EMA_UV_MANAGER';
  RightsConst.EMA_APP_ACCESS_ACTIVE = 'EMA_APP_ACCESS_ACTIVE';
  RightsConst.EMA_APP_ACCESS_V2 = 'EMA_APP_ACCESS_V2';
  RightsConst.BV = 'BV';
  RightsConst.BA = 'BA';
  RightsConst.BF = 'BF';
  RightsConst.FS = 'FS';
  RightsConst.EB = 'EB';
  RightsConst.EZ = 'EZ';
  RightsConst.LS = 'LS';
  RightsConst.ZA = 'ZA';
  RightsConst.OV = 'OV';
  RightsConst.RS = 'RS';
  RightsConst.RN = 'RN';
  RightsConst.SR = 'SR';
  RightsConst.SK = 'SK';
  RightsConst.KF = 'KF';
  RightsConst.SY = 'SY';
  RightsConst.TB = 'TB';
  RightsConst.TV = 'TV';
  RightsConst.DR = 'DR';
  RightsConst.AD = 'AD';
  RightsConst.DS = 'DS';
  RightsConst.BE = 'BE';
  RightsConst.ES = 'ES';
  RightsConst.ES_ADMIN = 'ES_ADMIN';
  RightsConst.HB = 'HB';
  RightsConst.ZE = 'ZE';
  RightsConst.MA = 'MA';
  RightsConst.UN = 'UN';
  RightsConst.LD = 'LD';
  RightsConst.VB = 'VB';
  RightsConst.ZU = 'ZU';
  RightsConst.LAGER_AB1 = 'LAGER_AB1';
  RightsConst.LAGER_ADM = 'LAGER_ADM';
  RightsConst.LAGER_AN1 = 'LAGER_AN1';
  RightsConst.LAGER_AB2 = 'LAGER_AB2';
  RightsConst.PZ_MAKLER_ANTRAG = 'PZ_MAKLER_ANTRAG';
  RightsConst.PZ_MAKLER_EXCELRECHNER = 'PZ_MAKLER_EXCELRECHNER';
  RightsConst.PZ_MAKLER_PERSON = 'PZ_MAKLER_PERSON';
  RightsConst.PZ_MAKLER_PROVKONTEN = 'PZ_MAKLER_PROVKONTEN';
  RightsConst.PZ_MAKLER_POLIZZEN = 'PZ_MAKLER_POLIZZEN';
  RightsConst.PZ_MAKLER_PROVISION = 'PZ_MAKLER_PROVISION';
  RightsConst.PZ_MAKLER_SCHADEN = 'PZ_MAKLER_SCHADEN';
  RightsConst.PZ_MAKLER_FAMILIENPASS = 'PZ_MAKLER_FAMILIENPASS';
  RightsConst.PZ_MAKLER = 'PZ_MAKLER';
  RightsConst.PZ_MAKLER_BUCHUNGEN = 'PZ_MAKLER_BUCHUNGEN';
  RightsConst.PZ_MAKLER_POL_AENDERUNG = 'PZ_MAKLER_POL_AENDERUNG';
  RightsConst.PZ_MAKLER_POL_VERSIONEN = 'PZ_MAKLER_POL_VERSIONEN';
  RightsConst.PZ_MAKLER_SCHWEBE = 'PZ_MAKLER_SCHWEBE';
  RightsConst.PZ_MAKLER_USERADMIN = 'PZ_MAKLER_USERADMIN';
  RightsConst.PZ_MAKLER_OFFERTSUCHE = 'PZ_MAKLER_OFFERTSUCHE';
  RightsConst.PZ_MAKLER_OMDS = 'PZ_MAKLER_OMDS';
  RightsConst.PZ_MAKLER_STATUSDRUCK = 'PZ_MAKLER_STATUSDRUCK';
  RightsConst.PZ_MAKLER_OFFERT = 'PZ_MAKLER_OFFERT';
  RightsConst.PZ_MAKLER_PERBANK = 'PZ_MAKLER_PERBANK';
  RightsConst.PZ_MAKLER_POLSCH_DETAIL = 'PZ_MAKLER_POLSCH_DETAIL';
  RightsConst.PZ_MAKLER_ADDOC = 'PZ_MAKLER_ADDOC';
  RightsConst.PZ_MAKLER_KLAUSEL = 'PZ_MAKLER_KLAUSEL';
  RightsConst.PZ_MAKLER_PERMAILING = 'PZ_MAKLER_PERMAILING';
  RightsConst.PZ_MAKLER_POL_RABATTE = 'PZ_MAKLER_POL_RABATTE';
  RightsConst.PZ_MAKLER_POL_REF = 'PZ_MAKLER_POL_REF';
  RightsConst.PZ_MAKLER_SCHZAHLDETAIL = 'PZ_MAKLER_SCHZAHLDETAIL';
  RightsConst.PZ_MAKLER_TERMINE = 'PZ_MAKLER_TERMINE';
  RightsConst.O30_BEANAL = 'O30_BEANAL';
  RightsConst.O30_ELEK = 'O30_ELEK';
  RightsConst.O30_ERWVN = 'O30_ERWVN';
  RightsConst.O30_ESIGN = 'O30_ESIGN';
  RightsConst.O30_GSM = 'O30_GSM';
  RightsConst.O30_IDDFREI = 'O30_IDDFREI';
  RightsConst.O30_KONTAUF = 'O30_KONTAUF';
  RightsConst.O30_KNDZUS = 'O30_KNDZUS';
  RightsConst.O30_LEBOFFDEL = 'O30_LEBOFFDEL';
  RightsConst.O30_READ = 'O30_READ';
  RightsConst.O30_OFFLIST = 'O30_OFFLIST';
  RightsConst.O30_RISIKO = 'O30_RISIKO';
  RightsConst.O30_WRITE = 'O30_WRITE';
  RightsConst.SU = 'SU';
  RightsConst.O30_VKEFIND = 'O30_VKEFIND';
  RightsConst.ZB = 'ZB';
  RightsConst.TXTBSTEDIT = 'TXTBSTEDIT';
  return RightsConst;
}();
exports.RightsConst = RightsConst;